import React, { useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { WebService } from "../../Services/WebService";
import { Form, FormInputText, FormInputDropdown } from "../Form";
import { useDispatch, useSelector } from "react-redux";
import _ from "underscore";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import { StandardConst } from "../../Services/StandardConst";
import { WSSuccessAlert, WSWarningAlert } from "../../Services/WSAlert";
import * as Yup from "yup";
import ActionButton from "../../Services/ActionButton";
import { isToday } from "date-fns";
import { Autocomplete, TextField } from "@mui/material";
const { forwardRef, useState, useImperativeHandle } = React;
const alphaNumericMessage =
  "Only letters, numbers, and spaces are allowed, and it can't be only numbers.";

const visitSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .matches(/^(?!^\d+$)[a-zA-Z0-9\s]+$/, alphaNumericMessage) // No only-numbers
    .required("Retailer name is required"),

  BussinessName: Yup.string()
    .trim()
    .matches(/^(?!^\d+$)[a-zA-Z0-9\s]+$/, alphaNumericMessage) // No only-numbers
    .required("Bussiness name is required"),

  phone: Yup.string()
    .trim()
    .matches(/^\d{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),

  email: Yup.string()
    .trim() // removes accidental spaces
    .email("Invalid email format")
    .required("Email is required"),
});
const AddEditTask = (prop, ref) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [data, setData] = useState({});
  const [typeOptions, setTypeOptions] = useState([]);
  const [date, setDate] = useState(new Date());
  const [projectList, setProjectList] = useState([]);
  const companyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});
  const [coordinates, setCoordinates] = useState({
    latitude: "",
    longitude: "",
  });
  const [locationError, setlocationError] = useState(null);
  const loggedUser = useSelector((s) => s.auth.LoggedUser ?? 0);
  const [photos, setPhotos] = useState([]);
  const [showCamera, setShowCamera] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [bussinessName, setbussinessName] = useState([]); // list of bussiness names
  const [BusinessDefaultValue, setBusinessDefaultValue] = useState("");
  const [defaultValues, setDefaultValues] = useState({});

  const [zoomPhoto, setZoomPhoto] = useState(null);
  console.log(visitSchema);
  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
        audio: false,
      });
      setShowCamera(true);
      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      }, 100);
    } catch (e) {
      console.error("Error starting camera:", e);
    }
  };

  const capturePhoto = async () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (photos.length >= 3) {
      WSWarningAlert("Warning", "You can only capture up to 3 selfies.");
      setShowCamera(false);

      return;
    }
    if (video && canvas) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const context = canvas.getContext("2d");
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      const base64Data = canvas.toDataURL("image/png");

      // Convert base64 to Blob
      const blob = await (await fetch(base64Data)).blob();

      // Create a File object
      const file = new File([blob], `selfie-${Date.now()}.png`, {
        type: "image/png",
      });

      // Show the preview using createObjectURL
      const previewUrl = URL.createObjectURL(file);

      // Save only to state for now, uploading can be done later
      setPhotos((prev) => [...prev, { file, previewUrl }]);
      setShowCamera(false);
    }
  };

  const removePhoto = (index, imageId = false) => {
    setPhotos((prev) => prev.filter((_, i) => i !== index));
    if (imageId) {
      removePhotoFromServer(imageId);
    }
  };

  useImperativeHandle(ref, () => ({
    openModal: async (id, projectId) => {
      setShow(true);
      if (id === 0) {
        await fetchData(id);
      } else {
        setShow(false);
        await fetchData(id);
        setShow(true);
      }
    },
  }));

  const getLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCoordinates({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          setlocationError(null);
        },
        (err) => {
          setlocationError(err.message);
        },
        {
          enableHighAccuracy: false,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      setlocationError("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    getLocation();
  }, []);
  const fetchData = async (visitId) => {
    if (!visitId) return null;
    try {
      const visitData = await WebService({
        endPoint: `CommonUtility/Edit/visits?visitId=${visitId}`,
      });
      const CustomerData = await WebService({
        endPoint: `CommonUtility/Edit/SalesCustomers?salesCustomersId=${
          visitData[0].salesCustomersId || 0
        }`,
      });
      const imagesData = await WebService({
        endPoint: `CommonUtility/fetchAll/VisitImages?VisitID=${visitId || 0}`,
      });
      setPhotos(imagesData);

      setDefaultValues({ ...CustomerData[0], ...visitData[0] });
      getBusiness(visitData[0].BussinessName);
      setDate(new Date(visitData[0].startTime));
      setBusinessDefaultValue(CustomerData[0]);
    } catch (error) {
      return null;
    }
  };
  const uploadFiles = async (File) => {
    try {
      const res = await WebService({
        endPoint: "upload/File",
        dispatch,
        body: File,
        isFile: true,
      });
      return res;
    } catch (err) {
      return null; // optional fallback
    }
  };

  const removePhotoFromServer = async (imgId) => {
    const result = await WebService({
      endPoint: `CommonUtility/VisitImages?ImageID=${imgId}`,
      method: "DELETE",
    });
  };
  console.log(photos);
  const handleClose = () => {
    setShow(false);
    setData({});
    setDefaultValues({});
    setTypeOptions([]);
    setProjectList([]);
    setShowCamera(false);
    setPhotos([]);
    setErrors({});
  };
  const [errors, setErrors] = useState({});

  const onSubmit = async (data) => {
    console.log(data);
    console.log(defaultValues);
    if (!defaultValues.BussinessName) {
      defaultValues.BussinessName = data.BussinessName;
    }

    try {
      await visitSchema.validate(defaultValues, { abortEarly: false });
      setErrors({}); // Clear errors
      console.log("✅ Form is valid:", defaultValues);
    } catch (validationError) {
      const newErrors = {};
      validationError.inner.forEach((err) => {
        newErrors[err.path] = err.message;
      });
      setErrors(newErrors);
      return;
    }
    data = { ...data };
    console.log("funciton called");

    let VistiData = {};
    let CustomerData = {};
    if (isToday(new Date(date))) {
      VistiData.status = "completed";
      data.startTime = new Date().toISOString();
      VistiData.scheduledDate = new Date().toISOString();
    } else {
      VistiData.status = "scheduled";
      VistiData.scheduledDate = new Date(date).toISOString();
    }

    VistiData.salesExecutiveId = loggedUser;
    VistiData.startTime = new Date(date).toISOString();
    VistiData.startLocationLat = coordinates.latitude;
    VistiData.startLocationLong = coordinates.longitude;
    VistiData.purpose = data.purpose;
    VistiData.remarks = data.remarks;
    VistiData.salesCustomersId =
      defaultValues.salesCustomersId || data?.salesCustomersId || 0;
    CustomerData.name = defaultValues?.name || data.name;
    CustomerData.BussinessName = defaultValues.BussinessName;
    CustomerData.locationName = data.locationName;
    CustomerData.phone = defaultValues.phone || data.phone;
    CustomerData.email = defaultValues.email || data.email;
    CustomerData.address = defaultValues.address;
    CustomerData.locationLat = coordinates.latitude;
    CustomerData.locationLong = coordinates.longitude;
    CustomerData.createdAt = new Date().toISOString();
    CustomerData.createdBy = loggedUser;

    CustomerData.salesCustomersId = defaultValues.salesCustomersId || data?.salesCustomersId || 0;

    // Insert Customer data



    var CustomerDataApiEndpoint = "CommonUtility/SalesCustomers";
    // if (defaultValues.salesCustomersId) {
      // CustomerDataApiEndpoint += `?salesCustomersId=${data.salesCustomersId}`;
    // }


console.log(data.salesCustomersId,'UAT-ERROR---?',defaultValues.salesCustomersId)
// &&   data.salesCustomersId !== defaultValues.salesCustomersId
if (defaultValues.salesCustomersId !== null && defaultValues.salesCustomersId !== undefined && defaultValues.salesCustomersId !== 0 ) {
     CustomerDataApiEndpoint += `?salesCustomersId=${data.salesCustomersId}`;
  // PUT request (update)
 
  await WebService({
    endPoint: CustomerDataApiEndpoint,
    method: "PUT",
    body: CustomerData,
    dispatch,
  }).then((res) => {
    WSSuccessAlert("Success", "Customer data updated successfully");
    if (res) {
      VistiData.salesCustomersId = res;
    }
  });
} else {

  // POST request (add new)
  await WebService({
    endPoint: CustomerDataApiEndpoint,
    method: "POST",
    body: CustomerData,
    dispatch,
  }).then((res) => {
    WSSuccessAlert("Success", "Customer data added successfully");
    if (res) {
      VistiData.salesCustomersId = res;
    }
  });
}

// ===================================
  //   if (defaultValues.salesCustomersId) {
  //     // alert(defaultV alert('11');alues.salesCustomersId ,'defaultValues.salesCustomersId 333');
  // alert('33');
  //     await WebService({
  //       endPoint: CustomerDataApiEndpoint,
  //       method: CustomerData.salesCustomersId ? "PUT" : "POST",
  //       body: CustomerData,
  //       dispatch,
  //     }).then((res) => {
  //       if (data.visitId) {
  //         WSSuccessAlert("Success", "Customer data updated successfully");
  //       } else {
  //         WSSuccessAlert("Success", "Customer data added successfully");
  //       }
  //       if (res) {
  //         VistiData.salesCustomersId = res;
  //       }
  //     });
  //   }

    // Insert Visit data
    var endPoint = "CommonUtility/visits";
    var method = "POST";
    if ((data.visitId ?? 0) > 0) {
      endPoint += `?visitId=${data.visitId}`;
      method = "PUT";
    }
    const uploadedFiles = await Promise.all(
      photos.map(async (file) => {
        return await uploadFiles(file.file);
      })
    );
    let visitId;
    await WebService({
      dispatch,
      endPoint,
      method,
      body: _.omit(VistiData, "visitId"),
    }).then((res) => {
      visitId = res;
      if (data.visitId !== undefined) {
        WSSuccessAlert("Success", ` updated successfully`);
      } else {
        WSSuccessAlert("Success", ` added successfully`);
      }
    });

    await Promise.all(uploadedFiles).then((res) => {
      uploadedFiles.forEach((file, index) => {
        if (file) {
          console.log(file);
          WebService({
            endPoint: "CommonUtility/VisitImages",
            dispatch,
            body: {
              VisitID: visitId || data.visitId,
              ImageURL: file?.filename,
            },
          });
        }
      });
    });

    prop.callBackEvent();
    handleClose();
  };

  const purposes = [
    { text: "Product Demo", value: "Product Demo" },
    { text: "Feedback", value: "Feedback" },
    { text: "Order Collection", value: "Order Collection" },
    { text: "Payment Collection", value: "Payment Collection" },
    { text: "Other", value: "Other" },
  ];

  const getBusiness = async (v) => {
    console.log(v);
    const data = await WebService({
      endPoint: `CommonUtility/SalesCustomers?BussinessName=${v}`,
      dispatch,
    });
    handleChange("BussinessName", v);
    setbussinessName(data);
  };

  const handleChange = (name, value) => {
    setDefaultValues((prev) => ({ ...prev, [name]: value }));
  };

  console.log(defaultValues);
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {(defaultValues.visitId || 0) === 0
            ? "Add Customer Visit"
            : "Edit Customer Visit"}
        </Modal.Title>
      </Modal.Header>
      <Form
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        // validationSchema={visitSchema}
      >
        <Modal.Body className="p-4">
          <Row>
            <Col md={12} className="mb-1  ">
              <p
                className="my-2 fw-light"
                style={{
                  fontFamily: "sans-serif",
                  fontSize: "14px",
                  color: "#5a5a5a",
                }}
              >
                Bussiness Name
              </p>
              <div className="flex-1">
                
                <Autocomplete
                  disabled={(defaultValues.visitId || 0) !== 0} 
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      padding: "1px 8px",
                    },
                  }}
                  id="grouped-demo"
                  options={bussinessName}
                  defaultValue={defaultValues}
                  getOptionLabel={(option) => option?.BussinessName || ""}
                  onInputChange={(e, v, reason) => {
                    if (reason === "input") {
                      getBusiness(v);
                    } else {
                      console.log(v);
                      handleChange("BussinessName", v);
                    }
                  }}
                  onChange={(e, v) => {
                    console.log(v);
                    setDefaultValues((prev) => ({
                      ...prev,
                      salesCustomersId: v?.salesCustomersId,
                      name: v?.name,
                      BussinessName: v?.BussinessName,
                      phone: v?.phone,
                      email: v?.email,
                      address: v?.address,
                    }));
                  }}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // label="Choose Job Supplemental Pay"
                      placeholder="search Bussiness Name"
                      sx={{
                        "& .MuiOutlinedInput-input": {
                          border: "none",
                          fontSize: "14px",
                        },
                      }}
                    />
                  )}
                />

                
                {errors.BussinessName && (
                  <div className="col-md-6">
                    <p style={{ color: "red" }}>{errors.BussinessName}</p>
                  </div>
                )}
              </div>
            </Col>
            <Col md={12}>
              <FormInputText
                label="Contact person"
                name="name"
                type="text"
                value={defaultValues.name}
                onChange={(e) => {
                  handleChange("name", e.target.value);
                }}
                className="form-control"
              />
              {errors.name && (
                <div className="col-md-6 offset-md-5">
                  <p style={{ color: "red" }}>{errors.name}</p>
                </div>
              )}
            </Col>
            <Col md={12}>
              <FormInputText
                label="Phone Number"
                name="phone"
                value={defaultValues.phone}
                onChange={(e) => handleChange("phone", e.target.value)}
                type="text"
                isRequired="true"
              />
              {errors.phone && (
                <div className="col-md-6 offset-md-5">
                  <p style={{ color: "red" }}>{errors.phone}</p>
                </div>
              )}
            </Col>
            <Col md={12}>
              <FormInputText
                label="Email"
                value={defaultValues.email}
                type="email"
                name="email"
                onChange={(e) => handleChange("email", e.target.value)}
                type="text"
              />
              {errors.email && (
                <div className="col-md-6 offset-md-5">
                  <p style={{ color: "red" }}>{errors.email}</p>
                </div>
              )}{" "}
            </Col>
            <Col md={12}>
              <FormInputText
                label="Location Name"
                name="address"
                onChange={(e) => handleChange("address", e.target.value)}
                type="text"
                value={defaultValues.address}
                isRequired="true"
              />
            </Col>
            <Col className="d-flex" md={12}>
              <p
                className="my-2 fw-light"
                style={{
                  flex: 1,
                  fontFamily: "sans-serif",
                  fontSize: "14px",
                  color: "#5a5a5a",
                }}
              >
                Latitude
              </p>
              <p className="my-2 fw-light" style={{ flex: 1 }}>
                {defaultValues.locationLat || coordinates.latitude}
              </p>
            </Col>
            <Col className="d-flex" md={12}>
              <p
                className="my-2 fw-light"
                style={{
                  flex: 1,
                  fontFamily: "sans-serif",
                  fontSize: "14px",
                  color: "#5a5a5a",
                }}
              >
                Longitude
              </p>
              <p className="my-2" style={{ flex: 1 }}>
                {defaultValues.locationLong || coordinates.longitude}
              </p>
            </Col>

            <Col md={12}>
              <FormInputDropdown
                label="Visit Purpose"
                name="purpose"
                className="form-control"
                ddOpt={purposes}
                isRequired="true"
              />
            </Col>
            {/* <Col md={12}>
              <FormInputDropdown
                label="Visit Status"
                name="status"
                className="form-control"
                ddOpt={StandardConst.statusOptions}
                isRequired="true"
              />
            </Col> */}
            <Col md={12}>
              <FormInputText
                label="Visit Date"
                name="startTime"
                type="datetime"
                value={date}
                onChange={(e) => {
                  setDate(e);
                }}
                className="form-control"
                isRequired="true"
              />
            </Col>

            <Col md={12}>
              <FormInputText
                label="Remarks"
                name="remarks"
                type="text"
                multiline
                rows={3}
                className="form-control"
                isRequired="true"
              />
            </Col>
          </Row>
        </Modal.Body>
        <div className="container -mt-2">
          {showCamera && (
            <>
              <video
                ref={videoRef}
                autoPlay
                playsInline
                className="w-100 rounded border"
              />
              <canvas ref={canvasRef} className="d-none" />
            </>
          )}

          <Col md={12} className=" d-flex justify-content-end gap-2">
            <button
              type="button"
              onClick={getLocation}
              className="btn mb-2 p-2 btn-sm btn-primary"
            >
              capture location
            </button>
            {!showCamera && (
              <button
                type="button"
                onClick={startCamera}
                className="btn mb-2 p-2 btn-sm btn-primary"
              >
                add photos
              </button>
            )}
            {showCamera && (
              <button
                type="button"
                onClick={capturePhoto}
                className="btn mb-2 p-2 btn-sm btn-primary"
              >
                Capture Selfie
              </button>
            )}
          </Col>

          {photos.length > 0 && (
            <div className="mt-4">
              <div className="d-flex flex-wrap gap-3">
                {photos.length > 0 && (
                  <Col className="mt-4" md={12}>
                    <p className="fw-bold mb-2">Captured Selfies:</p>
                    <ul className="list-group">
                      {photos.map((photo, index) => (
                        <li
                          key={index}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <div className="d-flex align-items-center gap-2">
                            {zoomPhoto && (
                              <div
                                onClick={() => setZoomPhoto(null)}
                                style={{
                                  position: "fixed",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  backgroundColor: "rgba(0,0,0,0.8)",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  zIndex: 9999,
                                  cursor: "zoom-out",
                                }}
                              >
                                <img
                                  src={zoomPhoto}
                                  alt="Zoomed"
                                  style={{
                                    maxWidth: "90%",
                                    maxHeight: "90%",
                                    borderRadius: "12px",
                                    boxShadow: "0 0 25px rgba(0,0,0,0.6)",
                                  }}
                                />
                              </div>
                            )}

                            <img
                              src={
                                photo?.previewUrl
                                  ? photo.previewUrl
                                  : `${StandardConst.apiBaseUrl}/uploads/${photo.ImageURL}`
                              }
                              alt={`Selfie ${index + 1}`}
                              style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                              }}
                              className="rounded abhi"
                              onClick={() =>
                                setZoomPhoto(
                                  photo?.previewUrl
                                    ? photo.previewUrl
                                    : `${StandardConst.apiBaseUrl}/uploads/${photo.ImageURL}`
                                )
                              }
                            />
                            <span>Selfie {index + 1}</span>
                          </div>
                          <ActionButton
                            type="button"
                            onClick={() => removePhoto(index, photo?.ImageID)}
                            className="btn btn-sm btn-outline-danger"
                            IconName="Delete"
                          />
                        </li>
                      ))}
                    </ul>
                  </Col>
                )}
              </div>
            </div>
          )}
        </div>
        <Modal.Footer>
          <Button id="btnTaskSubmit" variant="outline-primary" type="submit">
            {" "}
            {(data.TaskCategoryId || 0) === 0
              ? "Save Visit"
              : "Update Visit"}{" "}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default forwardRef(AddEditTask);
